/**
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema Golden Sisters
 * Arquivo: src/components/forms/CustomerForm.js
 * Versão: 1.1 - IMPLEMENTAÇÃO: Adicionado campo para 'subscriptionPlan'.
 * Permite que o plano de assinatura do cliente seja definido/atualizado no cadastro.
 * Data: 29 de julho de 2025 (Horário de Cubatão, SP)
 * Responsável pela Alteração: Gemini
 */
import React, { useState } from 'react';
import FormField from '../ui/FormField';
import { Loader2 } from 'lucide-react';

const CustomerForm = ({ onSave, onClose, customerData = null }) => {
    const [name, setName] = useState(customerData?.name || '');
    const [cpf, setCpf] = useState(customerData?.cpf || '');
    const [phone, setPhone] = useState(customerData?.phone || '');
    const [email, setEmail] = useState(customerData?.email || '');
    const [address, setAddress] = useState(customerData?.address?.fullAddress || '');
    // NOVO: Estado para o subscriptionPlan
    const [subscriptionPlan, setSubscriptionPlan] = useState(customerData?.subscriptionPlan || 'Aspirante');
    const [isSaving, setIsSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        // NOVO: Incluir subscriptionPlan no payload
        const payload = { 
            name, 
            cpf, 
            phone, 
            email, 
            address: { fullAddress: address },
            subscriptionPlan // Adicionado o campo subscriptionPlan
        };
        await onSave(payload, customerData?.id);
        setIsSaving(false);
        onClose();
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <FormField label="Nome Completo" id="customerName" type="text" value={name} onChange={e => setName(e.target.value)} required />
            <FormField label="CPF" id="customerCpf" type="text" value={cpf} onChange={e => setCpf(e.target.value)} />
            <FormField label="Telefone" id="customerPhone" type="tel" value={phone} onChange={e => setPhone(e.target.value)} />
            <FormField label="Email" id="customerEmail" type="email" value={email} onChange={e => setEmail(e.target.value)} required/>
            <FormField label="Endereço" id="customerAddress" type="textarea" rows="3" value={address} onChange={e => setAddress(e.target.value)} />
            
            {/* NOVO: Campo para Plano de Assinatura */}
            <div className="flex flex-col">
                <label htmlFor="subscriptionPlan" className="block text-sm font-medium text-gray-300 mb-2">Plano de Assinatura</label>
                <select
                    id="subscriptionPlan"
                    value={subscriptionPlan}
                    onChange={e => setSubscriptionPlan(e.target.value)}
                    className="w-full p-3 bg-gray-800 border border-gray-700 rounded-md focus:ring-brand-gold focus:border-brand-gold text-white"
                >
                    <option value="Aspirante">Aspirante (Aluguel Avulso)</option>
                    <option value="Clube Bronze">Clube Bronze</option>
                    <option value="Clube Prata">Clube Prata</option>
                    <option value="Clube Ouro">Clube Ouro</option>
                    <option value="Clube Diamante">Clube Diamante</option>
                </select>
            </div>

            <div className="flex justify-end space-x-3 pt-4 border-t border-gray-700 mt-6">
                <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500">Cancelar</button>
                <button type="submit" disabled={isSaving} className="px-6 py-2 bg-brand-gold text-brand-black font-semibold rounded-md hover:bg-yellow-500 flex items-center">
                    {isSaving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                    Salvar Cliente
                </button>
            </div>
        </form>
    );
};

export default CustomerForm;